/*
 * SecuritySetUp Messages
 *
 * This contains all the text for the SecuritySetUp scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.SecuritySetUp";

export default defineMessages(scope, {
  header: "Set up security methods",
  desc: "Security methods help protect your account by ensuring only you have access.",
  registrationSuccessMessage:
    "Your account registration is complete. Set up additional security methods or log in.",
  goToLoginButton: "Go to Log In",
  configuredAllMethods: "Your account registration is complete.",
});
